export default "__VITE_ASSET__GcjMgk$$__"